// ** Ellipsis Icons Data

export const ellipsisIcons = {
	"ellipsis-h": {
		viewBox: "0 0 512 512",
		variants: {
			solid: {
				"data-prefix": "fas",
				"data-icon": "ellipsis-h",
				source: "https://fontawesome.com/icons/ellipsis-h",
				license: "https://fontawesome.com/license",
				path: "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z",
			},
		},
	},
};
